<template>
  <section class="p-3 mx-auto border rounded-md">
    <div class=""></div>
    <div class="flex flex-col gap-6">
      <QuestionnairesGenericQuestionCard
        v-if="questionnaire.questions"
        :questions="questionnaire.questions" />
    </div>
  </section>
</template>
<script setup lang="ts">
import type { Questionnaire } from '@/types/Questionnaires';
import QuestionnairesGenericQuestionCard from './QuestionnairesGenericQuestionCard.vue';

defineProps<{
  questionnaire: Questionnaire;
}>();
</script>
